import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { transportProviderAPI } from '../../services/api';

const QUOTE_STATUS_LABELS = {
  pending: { label: 'بانتظار رد العميل', color: 'bg-amber-100 text-amber-700' },
  accepted: { label: 'مقبول', color: 'bg-emerald-100 text-emerald-700' },
  not_selected: { label: 'لم يُختر', color: 'bg-gray-100 text-gray-500' },
  withdrawn: { label: 'مسحوب', color: 'bg-gray-100 text-gray-500' },
};

const TransportProviderQuotesPage = () => {
  const [quotes, setQuotes]   = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    transportProviderAPI.getMyQuotes()
      .then((res) => setQuotes(res.data.data || []))
      .catch(() => toast.error('فشل في تحميل العروض'))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    load();
    let interval = setInterval(load, 15000);
    const handleVisibility = () => {
      if (document.hidden) {
        clearInterval(interval);
      } else {
        load();
        interval = setInterval(load, 15000);
      }
    };
    document.addEventListener('visibilitychange', handleVisibility);
    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', handleVisibility);
    };
  }, []);

  return (
    <div dir="rtl" className="p-4 sm:p-6">
      <h1 className="text-xl font-black text-gray-800 mb-6">📩 عروضي</h1>

      {loading ? (
        <div className="text-center text-gray-400 py-16">جاري التحميل...</div>
      ) : quotes.length === 0 ? (
        <div className="bg-white rounded-2xl border border-gray-100 p-10 text-center text-gray-400">لم تقدّم أي عروض بعد</div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {quotes.map((q) => (
            <div key={q.id} className="bg-white rounded-2xl border border-gray-100 shadow-sm p-5">
              <div className="flex items-center justify-between mb-2">
                <span className="text-xs font-mono text-gray-400">{q.request?.requestNumber}</span>
                <span className={`text-xs font-bold px-2 py-0.5 rounded-full ${QUOTE_STATUS_LABELS[q.status]?.color}`}>
                  {QUOTE_STATUS_LABELS[q.status]?.label || q.status}
                </span>
              </div>
              <p className="text-sm font-bold text-gray-800 mb-1">{q.request?.fromLabel} ← {q.request?.toLabel}</p>
              <p className="text-lg font-black text-blue-700">{q.price} ج.س</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TransportProviderQuotesPage;
